// src/services/productService.js
import apiService from "./apiService"; // Import the reusable API service

const PRODUCT_API_URL = "/products"; // Base endpoint for product-related operations

/**
 * Fetch all products with optional pagination.
 * @param {number} page - The page number to fetch.
 * @param {number} limit - The number of products per page.
 * @returns {Array} - The array of product objects.
 * @throws Will throw an error if the API request fails or returns unexpected data.
 */
export const getAllProducts = async (page = 1, limit = 10) => {
  try {
    const response = await apiService.get(PRODUCT_API_URL, {
      params: { page, limit },
    });

    // Check if the response structure is valid
    if (response?.data?.success && Array.isArray(response.data.data)) {
      return response.data.data; // Return the array of products
    } else {
      throw new Error("Invalid API response structure");
    }
  } catch (error) {
    console.error("Error fetching products:", error.message);
    throw new Error("Failed to fetch products. Please try again later.");
  }
};

// Fetch a single product by ID
export const getProductById = async (productId) => {
  try {
    const response = await apiService.get(`${PRODUCT_API_URL}/${productId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Create a new product
export const createProduct = async (productData) => {
  try {
    const response = await apiService.post(PRODUCT_API_URL, productData);
    return response;
  } catch (error) {
    throw error;
  }
};

// Update an existing product by ID
export const updateProduct = async (productId, productData) => {
  try {
    const response = await apiService.put(
      `${PRODUCT_API_URL}/${productId}`,
      productData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete a product by ID
export const deleteProduct = async (productId) => {
  try {
    const response = await apiService.delete(`${PRODUCT_API_URL}/${productId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
